import { memo, useEffect, useState } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import ProductTagService from "@/services/product_tag"
import ProductCategoryService from "@/services/product_category"
import { Box, Button, Center, Spacer, Stack, Text } from "@chakra-ui/react"
import HomeBanner from "./HomeBanner";
import { Tabs } from "@chakra-ui/react"
import { LuCheck, LuFolder, LuSquareCheck, LuUser } from "react-icons/lu"
import _ from "lodash"
import ProductBlock from "./blocks/Product"
import ProductAllBlock from "./blocks/ProductAll"
import ProductCollectionBlock from "./blocks/ProductCollection"
import ImageBlock from "./blocks/Image"
import ImageCarousel from "./blocks/ImageCarousel"
import ImageCarouselSmall from "./blocks/ImageCarouselSmall"
import { useToken } from '@chakra-ui/react';
import { Separator, HStack } from '@chakra-ui/react';
const Block = ({ data }) => {



    const renderChild = () => {
        switch (data.type) {
            case "product":
                return <ProductBlock data={data}></ProductBlock>
                break;
            case "image":
                return <ImageBlock data={data}></ImageBlock>
                break;
            case "product_all":
                return <ProductAllBlock data={data}></ProductAllBlock>
                break;
            case "product_collection":
            case "product_collections":
                return <ProductCollectionBlock data={data}></ProductCollectionBlock>
                break;
            case "multi_image":
                if (data.setting.display == "carousel_small") {
                    return <ImageCarouselSmall data={data}></ImageCarouselSmall>
                }
                return <ImageCarousel data={data}></ImageCarousel>
                break;
            default:
                break;
        }

    }


    return (
        <div>
            {data.setting.show_title &&



                <SeparatorWithText text={data.setting.title}>

                </SeparatorWithText>


            }

            {renderChild()}
        </div>
    )

}


function SeparatorWithText({ text }) {
    return (
        <div style={{ margin: 8 }}>


            <HStack>
                <Separator flex="1" />
                <Text flexShrink="0" color={"colorPalette.600"} textStyle="md" fontWeight="semibold" lineClamp={1}>{text}</Text>
                <Separator flex="1" />
            </HStack>
        </div>

    );
}


export default memo(Block)